<main *ngIf="!fatura || !fatura.dueDate" class="fullheight">
  <p>
    <img src="assets/img/empty.png">
  </p>
  <h1>Fatura não disponível</h1>
</main>


<main *ngIf="fatura && fatura.dueDate">
  <p>
    <ae-tags *ngIf="!fatura.isOverdue">{{fatura.bankSliptStatus}}</ae-tags>
    <ae-tags *ngIf="fatura.isOverdue">Atrasado</ae-tags>
  </p>
  <p class="titulovalor">
    <strong>{{fatura.title}}</strong>
  </p>

  <p class="vencimento ae-error-color-text" *ngIf="fatura.isOverdue">
    <span>Venceu no dia </span>
    {{dateStringToBrazil(fatura.dueDate)}}
  </p>
  <p class="vencimento" *ngIf="!fatura.isOverdue">
    <span>Pague até o dia </span>
    {{dateStringToBrazil(fatura.dueDate)}}
  </p>


  <p *ngIf="fatura.isAutoNegotiationRedirectionEnabled">
    <ae-infos class="error" [style.width.%]="100">
      Essa fatura já venceu há mais de 30 dias. Não se preocupe, vamos te ajudar com condições especiais. 
    </ae-infos>
  </p>

  <p *ngIf="fatura.isOverdue && !fatura.isAutoNegotiationRedirectionEnabled && !showTicket">
    <ae-infos class="error" [style.width.%]="100">
      Esta fatura já venceu. O valor será atualizado com juros e multas. 
    </ae-infos>
  </p>



  <p>
    <ae-infos [style.width.%]="100">
      {{fatura.description}}
    </ae-infos>
  </p>
  <ae-infos class="prices" [style.width.%]="100">
    Mensalidade
    <div>{{formatCurrencyBrazil(fatura.value.toString())}}</div>
  </ae-infos>
  <hr>
  <ae-infos class="amount" [style.width.%]="100">
    <strong>Valor</strong>
    <div><strong>{{formatCurrencyBrazil(fatura.value.toString())}}</strong></div>
  </ae-infos>
  <ae-hr></ae-hr>

  <div *ngIf="fatura.isOverdue && !fatura.isAutoNegotiationRedirectionEnabled && !showTicket">
    Após o vencimento da fatura {{fatura.dueDate | date:'dd/MM/YYYY'}} multa de {{ formatCurrencyBrazil(faturaDetalhada.juros.toString())}} ao mês e mora diária de {{ formatCurrencyBrazil(faturaDetalhada.mora.toString()) }}. 
    Dúvidas entre em contato {{ faturaDetalhada.telefoneEscola }} ou {{ faturaDetalhada.emailEscola }}
  </div>

  
  <div *ngIf="!fatura.isAutoNegotiationRedirectionEnabled && showTicket">
    <p class="textInfo">
      Copie o código para realizar o pagamento
    </p>
    <ae-infos class="barcode" idContent="barcode" style="margin-top: 2px !important;">
      {{faturaDetalhada.linhaDigitavel}}
    </ae-infos>
    <div style="clear:both"></div>
  </div>
</main>
